import { useNotification } from '@/containers'
import Link from 'next/link'
import ImageOptimize from '../ImageOptimize'

export const HeaderLogo = () => {
  const { systemConfig } = useNotification()
  return (
    <Link href={'/'} className='flex gap-1 items-center outline-0 w-full'>
      <ImageOptimize
        loading='eager'
        priority
        className='w-full'
        alt={'Điện máy kho'}
        src={systemConfig?.warehouseLogoMobile || ''}
        width={84}
        height={60}
      />
    </Link>
  )
}
